<div class="w-full h-full flex justify-content-center">
  <div class="flex flex-column step-content">
    <div class="display-sm-semibold text-gray-900">Kreirajte pristup nalogu</div>
    <div class="mt-2-5 text-md-regular text-gray-600">Unesite email adresu i lozinku za prijavljivanje.</div>
    <div class="mt-5 flex">
      <app-info-circle stroke="#2970FF"></app-info-circle>
      <div class="ml-2-5 text-sm-medium text-gray-600">Pored prijavljivanja, email adresa se koristi za slanje faktura i potvrda</div>
    </div>
    <app-field label="Email adresa" for="email" class="mt-5">
      <app-email-input
        ctrlPlaceholder="Unesite email adresu"
        [formCtrl]="form().controls.email | formControl"
      >
      </app-email-input>
    </app-field>
    <app-field label="Lozinka" for="password" class="mt-3-5">
      <app-text-input
        [hasIcon]="true"
        formCtrlType="password"
        ctrlPlaceholder="Unesite lozinku"
        [formCtrl]="form().controls.password | formControl"
      >
        <app-lock-03 stroke="#ADB0B8"></app-lock-03>
      </app-text-input>
    </app-field>
    <app-password-requirements class="block mt-2" [password]="form().controls.password.value"></app-password-requirements>
    <app-field label="Potvrdi lozinku" for="confirmPassword" class="mt-3-5">
      <app-text-input
        [hasIcon]="true"
        formCtrlType="password"
        ctrlPlaceholder="Unesite lozinku ponovo"
        [formCtrl]="form().controls.confirmPassword | formControl"
      >
        <app-lock-03 stroke="#ADB0B8"></app-lock-03>
      </app-text-input>
    </app-field>
    <div class="mt-3-5 flex justify-content-between align-items-center">
      <app-button [btnSeverity]="ButtonSeverity.OUTLINE" [btnSize]="ButtonSize.MD" (btnClicked)="back.emit()">
        <app-arrow stroke="#181D27" direction="left"></app-arrow>
        <div class="text-sm-semibold text-gray-900">Nazad</div>
      </app-button>
      <app-button [btnSeverity]="ButtonSeverity.SUCCESS" [btnSize]="ButtonSize.MD" (btnClicked)="submit.emit()" [isBtnDisabled]="!isValid()">
        <div class="text-sm-semibold text-white">Kreiraj nalog</div>
        <app-arrow stroke="white" direction="right"></app-arrow>
      </app-button>
    </div>
  </div>
</div>
